import AuthCMS from "../../Layouts/AuthCMS"
import {  getSupport } from '../../Stores/AuthSlice';
import { useSelector } from 'react-redux';
import FacebookIcon from '../../Layouts/AuthCMS/Icon/Facebook';
import TelegramIcon from '../../Layouts/AuthCMS/Icon/Telegram';
import ZaloIcon from '../../Layouts/AuthCMS/Icon/Zalo';


const AppList = () => {
    const support = useSelector(getSupport)
    return (
        <AuthCMS tabActive={"/privacy"}>
            <div className="flex flex-wrap p-4">
                <div className="nt-theme-content nt-clearfix content-container">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">1. Chính sách quyền riêng tư</h2>
                    <p className="text-gray-700 mb-4">
                        Khi truy cập trang web hoặc sử dụng dịch vụ của BasicProxy, bạn có thể cần cung cấp một số thông tin cá nhân để hỗ trợ việc nhận diện và phục vụ bạn tốt hơn. Những thông tin này cho phép BasicProxy (“chúng tôi”, “của chúng tôi”) đảm bảo trải nghiệm sử dụng dịch vụ một cách hiệu quả và an toàn.
                    </p>
                    <p className="text-gray-700 mb-4">
                        Tại BasicProxy, chúng tôi cam kết đặt quyền riêng tư của người dùng, khách hàng và đối tác lên hàng đầu. Chính sách này giải thích cách thức thu thập, quản lý và bảo vệ dữ liệu cá nhân thông qua trang web và ứng dụng của chúng tôi. Chính sách này áp dụng cho mọi người truy cập, đăng ký tài khoản hoặc sử dụng sản phẩm, dịch vụ (gọi chung là “người dùng”). Chúng tôi khuyến khích bạn đọc kỹ tài liệu này trước khi sử dụng dịch vụ của BasicProxy, vì việc sử dụng tiếp tục được coi là đồng ý với các điều khoản trong chính sách quyền riêng tư này.
                    </p>
                    <hr className="border-t border-gray-300 my-6" />
                    <h3 className="text-xl font-semibold text-gray-800 mb-4">2. Thu thập thông tin cá nhân</h3>
                    <p className="text-gray-700 mb-4">
                        Chúng tôi thu thập thông tin cá nhân của người dùng để cải thiện chất lượng dịch vụ và hỗ trợ người dùng tốt nhất. Dữ liệu thu thập bao gồm nhưng không giới hạn:
                    </p>
                    <ul className="list-disc list-inside text-gray-700 mb-4">
                        <li><strong>Email:</strong> để liên lạc và hỗ trợ.</li>
                        <li><strong>Số điện thoại:</strong> để xác thực và hỗ trợ giao dịch.</li>
                        <li><strong>Họ và tên:</strong> để cá nhân hóa dịch vụ.</li>
                        <li><strong>Tên đăng nhập (Username):</strong> để quản lý tài khoản.</li>
                        <li><strong>Thông tin từ bên thứ ba:</strong> được thu thập tự động nhằm cải thiện trải nghiệm người dùng.</li>
                        <li><strong>Dữ liệu thanh toán tự động:</strong> được xử lý thông qua hệ thống an toàn.</li>
                    </ul>
                    <h4 className="text-lg font-semibold text-gray-800 mb-4">Thông tin thanh toán</h4>
                    <p className="text-gray-700 mb-4">
                        Chúng tôi cung cấp các phương thức thanh toán đa dạng để người dùng dễ dàng thực hiện giao dịch. Tuy nhiên, BasicProxy không trực tiếp thu thập thông tin thanh toán. Tất cả thông tin liên quan đến thanh toán đều được bảo mật thông qua các hệ thống ngân hàng và đơn vị trung gian mà bạn lựa chọn.
                    </p>
                    <hr className="border-t border-gray-300 my-6" />
                    <h3 className="text-xl font-semibold text-gray-800 mb-4">3. Thay đổi chính sách quyền riêng tư</h3>
                    <p className="text-gray-700 mb-4">
                        BasicProxy có quyền cập nhật hoặc sửa đổi chính sách quyền riêng tư bất kỳ lúc nào nhằm đáp ứng yêu cầu pháp lý hoặc cải tiến dịch vụ. Khi có thay đổi, chúng tôi sẽ công bố rộng rãi thông qua trang web hoặc ứng dụng. Chúng tôi khuyến nghị người dùng thường xuyên kiểm tra để nắm rõ các cập nhật mới nhất.
                    </p>
                    <hr className="border-t border-gray-300 my-6" />
                    <h3 className="text-xl font-semibold text-gray-800 mb-4">4. Liên hệ</h3>
                    <div className="flex items-center space-x-4">
                        {support.facebook && (
                            <a href={support.facebook} target='_blank' className='w-6 cursor-pointer'>
                                <FacebookIcon />
                            </a>
                        )}
                        {support.telegram && (
                            <a href={support.telegram} target='_blank' className='w-6 cursor-pointer'>
                                <TelegramIcon />
                            </a>
                        )}
                        {support.zalo && (
                            <a href={support.zalo} target='_blank' className='w-6 cursor-pointer'>
                                <ZaloIcon />
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </AuthCMS>
    )
}

export default AppList